module.exports = __webpack_public_path__ + "img/rise.ecb025bf.jpg";